import { ReactNode, useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { shallow } from 'zustand/shallow';

import { ToastType } from '@models';
import { useStore } from '@store';

const ToastProvider: React.FC = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation();
  const { currentToast } = useStore(
    (state) => ({
      currentToast: state.toast
    }),
    shallow
  );

  useEffect(() => {
    if (!currentToast) return;
    const toastId = `${currentToast.type}:${currentToast.message}`;
    switch (currentToast.type) {
      case ToastType.SUCCESS:
        toast.success(t(currentToast.message), { toastId });
        break;
      case ToastType.ERROR:
        toast.error(t(currentToast.message), { toastId });
        break;
      case ToastType.INFO:
        toast.info(t(currentToast.message), { toastId });
        break;
      case ToastType.WARNING:
        toast.warning(t(currentToast.message), { toastId });
        break;
    }
  }, [currentToast]);

  return <>{children}</>;
};

export default ToastProvider;
